// extracted by mini-css-extract-plugin
export default {"root":"InvitedUniversityContainer_root__ev5Pi","clusterBtn":"InvitedUniversityContainer_clusterBtn__tOde+","activeBtn":"InvitedUniversityContainer_activeBtn__BHs1n"};